module.exports = __webpack_public_path__ + "img/astronaut-helmet.ecbf921e.svg";